import { render, staticRenderFns } from "./SolicitudServicios.vue?vue&type=template&id=5195bdf8&scoped=true"
import script from "./SolicitudServicios.vue?vue&type=script&lang=js"
export * from "./SolicitudServicios.vue?vue&type=script&lang=js"
import style0 from "./SolicitudServicios.vue?vue&type=style&index=0&id=5195bdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195bdf8",
  null
  
)

export default component.exports